import React from "react";

import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const ReminderVehiclesDashboard = lazyLoader(
  () =>
    import(
      "Containers/ReminderVehicles/ReminderVehiclesDashboard/ReminderVehiclesDashboard"
    )
);

export const ReminderVehiclesListPage = () => {
  return (
    <Layout>
      <ReminderVehiclesDashboard />
    </Layout>
  );
};
